import React from "react";
import PropTypes from "prop-types";

// < href="#" onClick> is not accessible but our <button>
// has a ton of CSS on it, so if you have to use an <a> with an onClick
// then at least use this one

const LinkButton = React.forwardRef(({ children, ...rest }, ref) => (
  <a
    style={{ cursor: rest.disabled ? "not-allowed" : "pointer" }}
    role="button"
    aria-label={rest["aria-label"] || rest.title}
    tabIndex={rest.disabled ? undefined : 0}
    ref={ref}
    onKeyDown={event => {
      if (event.key === "Enter" && typeof rest.onClick === "function") {
        rest.onClick(event);
      }
    }}
    {...rest}
  >
    {children}
  </a>
));

LinkButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.number, PropTypes.array]),
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

LinkButton.defaultProps = {
  children: () => null,
};

export default LinkButton;
